module.exports = __webpack_public_path__ + "static/media/wa-background.8c20254f.png";